import React from 'react';

import styled from 'styled-components';

import ShopRequestUserAvatar from './ShopRequestUserAvatar';
import { MysteryShopRequestInbound } from './types';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
`;

type Props = {
  shopRequest: MysteryShopRequestInbound;
  field: 'shopper' | 'auditor';
  unassignedLabel?: string;
};

const ShopRequestUserInfo = ({ shopRequest, field, unassignedLabel = 'Unassigned' }: Props) => {
  const assignedUser = shopRequest[field];

  if (!assignedUser) {
    return <div>{unassignedLabel}</div>;
  }

  return (
    <Container>
      <ShopRequestUserAvatar label={assignedUser.name} />
      {assignedUser.name}
    </Container>
  );
};

export default ShopRequestUserInfo;
